<template>
  <div>
    <fieldset class="border p-3">
      <legend class="auto-wp">
        <small style="font-size:15px; font-weight: bold">manage invoices</small>
      </legend>
      <div></div>
      <div class="invoicesLoader">
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        <i class="fa fa-spinner fa-spin" style="font-size:24px; color: blue"></i>loading invoices...
      </div>
      <vue-good-table
        :columns="columns"
        :rows="systemInvoices"
        :fixed-header="true"
        :pagination-options="{
            enabled: true,
            mode: 'records',
            perPage: 6,
            position: 'bottom',
            perPageDropdown: [3, 7, 9],
            dropdownAllowAll: false,
            setCurrentPage: 1,
            nextLabel: 'next',
            prevLabel: 'prev',
            rowsPerPageLabel: 'Rows per page',
            ofLabel: 'of',
            pageLabel: 'page', // for 'pages' mode
            allLabel: 'All',
        }"
      >
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field === 'Action'">
            <button
              type="submit"
              class="btn btn-primary btn-sm btn-rounded invoice_id"
              @click="viewInvoice(props.row.id)"
            >
              <i class="fa fa-plus"></i> print invoice
            </button>
          </span>
        </template>
      </vue-good-table>
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      columns: [
        {
          label: "File code",
          field: "file_code",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter by file code"
          }
        },
        {
          label: "Customer name",
          field: "customer_name",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter customer"
          }
        },
        {
          label: "Bill of landing",
          field: "bill_landing",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter by bol"
          }
        },
        {
          label: "Sub total",
          field: "sub_total",
          type: "text"
        },
        {
          label: "Grand total",
          field: "grand_total",
          type: "text"
        },
        {
          label: "Invoice no",
          field: "invoice_no",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter by inv no"
          }
        },
        {
          label: "Action",
          field: "Action",
          width: "122px",
          html: true
        }
      ]
    };
  },
  created() {
    this.loadInvoices();
  },
  computed: {
    ...mapGetters(["systemInvoices"])
  },
  methods: {
    ...mapActions(["loadInvoices", "viewInvoice"])
  }
};
</script>


// WEBPACK FOOTER //
// src/invoices/manageinvoices.vue